import { render, staticRenderFns } from "./shopUse.vue?vue&type=template&id=7bac672a&"
import script from "./shopUse.vue?vue&type=script&lang=js&"
export * from "./shopUse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports